import React, { forwardRef } from 'react';
import cx from 'classnames';
import { resolveHyperlinkFont } from './Hyperlink.helpers';
import { useHyperlink } from './useHyperlink';
import styles from './Hyperlink.module.scss';
export const Hyperlink = forwardRef(({ as: HyperlinkElement = 'a', inherit = false, label, size = 'medium', underline = true, variant = 'primary', weight = 'regular', ...props }, ref) => {
    const { hyperlinkProps } = useHyperlink({ ...props, as: HyperlinkElement });
    const type = resolveHyperlinkFont({ inherit, size, weight });
    return (<HyperlinkElement ref={ref} {...hyperlinkProps} className={cx(styles.hyperlink, type, {
            [styles[variant]]: !inherit,
            [styles.underline]: underline,
        })}>
					{label}
				</HyperlinkElement>);
});
Hyperlink.displayName = 'Hyperlink';
